<div class="dashboard-container">
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-content">
      <mat-icon class="hero-icon">analytics</mat-icon>
      <h1>NRG Metrics Dashboard</h1>
      <p>Corporate Governance & Financial Analysis Platform</p>
    </div>
  </section>

  <!-- Quick Access Section -->
  <section class="quick-access-section">
    <h2 class="section-title">Quick Access</h2>
    <div class="quick-access-grid">
      <mat-card
        *ngFor="let card of quickAccessCards()"
        class="access-card"
        [class.disabled]="card.disabled"
        (click)="navigateTo(card)">
        <mat-card-content>
          <div class="card-icon-wrapper" [style.background-color]="card.color">
            <mat-icon class="card-icon">{{ card.icon }}</mat-icon>
          </div>
          <h3 class="card-title">{{ card.title }}</h3>
          <p class="card-description">{{ card.description }}</p>
        </mat-card-content>
      </mat-card>
    </div>
  </section>
</div>
